module.exports = __webpack_public_path__ + "static/media/Alba soffa 3-sits 180_2 tyg Neve Cream 5 miljö 2024 ny.eb716980.jpg";